import React from "react";
import AccountDropdown from "./account-dropdown.jsx";
import { Stack, Box } from "@mui/material";
import CalendarMenu from "./calendar-menu.jsx";
import "../../../styles/analytics/wrapper.scss";

const FiltersPanel = ({
  accountCheckList,
  setAccountCheckList,
  accountAnalytics,
  currentPeriodRange,
  comparisonPeriodRange,
  setCurrentPeriodRange,
  setComparisonPeriodRange,
  currentPeriod,
  comparePeriod,
  setCurrentPeriod,
  setComparePeriod,
}) => {
  return (
    <Box className="filter-panel">
      <AccountDropdown
        accountCheckList={accountCheckList}
        setAccountCheckList={setAccountCheckList}
        accountAnalytics={accountAnalytics}
      />

      {currentPeriodRange && comparisonPeriodRange && (
        <CalendarMenu
          currentPeriodRange={currentPeriodRange}
          comparisonPeriodRange={comparisonPeriodRange}
          setCurrentPeriodRange={setCurrentPeriodRange}
          setComparisonPeriodRange={setComparisonPeriodRange}
          currentPeriod={currentPeriod}
          comparePeriod={comparePeriod}
          setCurrentPeriod={setCurrentPeriod}
          setComparePeriod={setComparePeriod}
        />
      )}
    </Box>
  );
};

export default FiltersPanel;
